'use strict';

import _ from 'lodash';
import React, {PropTypes} from 'react';

import DropDownMenu from '../../../../common/components/c_DropDownMenu';
export default function ReferenceListPlacementSpecialists(props) {
  const profile = props.profile;
  const handleAssignPS = props.onAssignPS;
  const defaultOption = {value: 0, primaryText: 'Placement Specialist'};
  let placementSpecialists = [];
  if (!_.isEmpty(props.specialists)) {
    placementSpecialists = props.specialists.map(item =>
      ({value:item.employeeId, primaryText:`${item.firstName} ${item.lastName}`})
    );
  }
  const menuItems = [defaultOption, ...placementSpecialists];

  return (
    <div className='references-list-placement-specialists'>
      <div className='label'>Placement Specialist:</div>
      <DropDownMenu
        data-id={'Placement Specialist'}
        defaultValue={profile.placementSpecialistId || 0}
        menuItems={menuItems}
        onChange={(event, value) => handleAssignPS(value)} />
    </div>
  );
}

ReferenceListPlacementSpecialists.propTypes = {
  profile: PropTypes.object.isRequired,
  onAssignPS: PropTypes.func.isRequired,
  specialists: PropTypes.array
};



// WEBPACK FOOTER //
// ./shared/react/admin/ReferencesList/placementSpecialists/index.js